/* eslint-disable react-hooks/exhaustive-deps */
import withValidarRecuperar from 'HOC/withValidarRecuperar';
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import Breadcrumcomponent from 'components/BreadCrumbMex/BreadCrumb';
import BreadCurmbPasos from 'components/BreadCrumbMex/BreadCrumbTipo2';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { HideField, TextInput } from 'components/InputsMex/inputs';
import Page from 'components/Page';
import EmisionFooterBarButtons from 'components/Polizas/EmisionFooterBarButtons';
import { ambienteAplicacion } from 'constants/urls';
import { useNavbarContext } from 'contexts/NavbarContext';
import useCustomRouter from 'hooks/useCustomRouter';
import useCustomToast from 'hooks/useCustomToasts';
import usePasosEmision from 'hooks/usePasosEmision';
import useQueryParams from 'hooks/useQueryParams';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { PASOS_BREADCRUMBS, PRODUCTOS } from 'utils/constants';
import Loading from 'wrappers/Loading';
import './styles.scss';
import { urlGuardarDatosRiesgo, urlRecuperarDatosRiesgo } from './urls';

const RiesgoAuto = () => {
  useNavbarContext(PRODUCTOS.APINDIVIDUAL);

  const methods = useForm({
    mode: 'onChange',
  });

  const history = useCustomRouter();

  const qParams = useQueryParams();

  const { addWarningToast, addSuccessToast } = useCustomToast();

  const { handleSubmit, reset } = methods;
  const [loading, setLoading] = useState(true);
  const [catalogo, setCatalogo] = useState({});
  const { verificarPolizaCompletada } = usePasosEmision();

  const [routes, setRoutes] = useState({});
  const { idPoliza, codProducto } = qParams;
  const [validacionSerie, setValidacionSerie] = useState('');

  const requiredMessage = 'Este campo es obligatorio';
  const [imagenes, setImagenes] = useState({});

  const getData = async () => {
    setLoading(true);

    const body = {
      datosCotizador: {
        ambiente: ambienteAplicacion,
        prodCodigo: 'AUTO',
        cotPasoCodigo: 'listarDatosRiesgo',
        polCodigo: idPoliza,
      },
    };
    const res = await ApiKeyFetch.instance().post(urlRecuperarDatosRiesgo, body);
    if (res.transaccion) {
      const catalogoTmp = res.catalogo.listarDatosRiesgo;
      const sexo = res.catalogo.listarDatosRiesgo.sexo.map((item) => ({
        label: item.label,
        value: item,
      }));
      const ecivil = res.catalogo.listarDatosRiesgo.estadosCiviles.map((item) => ({
        label: item.label,
        value: item,
      }));
      catalogoTmp.sexo = sexo;
      catalogoTmp.estadosCiviles = ecivil;
      setCatalogo(catalogoTmp);

      const rulesSerie = catalogoTmp?.validaciones?.filter((item) => item.id === 'serie');
      setValidacionSerie(rulesSerie[0].rules);
      verificarPolizaCompletada(catalogoTmp?.pasosRedireccionamiento);
      setRoutes(catalogoTmp?.pasosRedireccionamiento);

      const usoFromBase = catalogoTmp?.validaciones?.filter(
        (item) => item.id === 'usoDefaultValue'
      );
      let tipoUso = usoFromBase?.[0]?.defaultValue || 'USO PERSONAL';
      if (catalogoTmp.datosRiesgo) {
        const { datosRiesgo } = catalogoTmp;
        if (datosRiesgo.tipoUso && datosRiesgo.tipoUso !== '') {
          tipoUso = datosRiesgo.tipoUso;
        }
        reset({
          datosRiesgo: {
            ...datosRiesgo,
            tipoUso,
          },
        });
      } else {
        //Agregado para cargar el valor Default del tipo de uso
        reset({
          datosRiesgo: {
            tipoUso,
          },
        });
      }

      if (catalogoTmp.imagenes) {
        const imgPlaca = catalogoTmp?.imagenes?.filter((item) => item.id === 'placa');
        const imgMotor = catalogoTmp?.imagenes?.filter((item) => item.id === 'motor');
        const imgSerie = catalogoTmp?.imagenes?.filter((item) => item.id === 'serie');
        setImagenes({
          imgplaca: imgPlaca[0]?.url,
          imgmotor: imgMotor[0]?.url,
          imgserie: imgSerie[0]?.url,
        });
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const onSubmit = async (data) => {
    const formData = { ...data };
    data.datosRiesgo.marca = catalogo?.marca;
    data.datosRiesgo.modelo = catalogo?.modelo;
    data.datosRiesgo.anio = catalogo?.anio;
    data.datosRiesgo.sisa = catalogo?.sisa;
    await guardarInformacion(data.datosRiesgo, false, formData);
  };

  const guardarInformacion = async (data, guardarDatos = true, formData) => {
    window.onpopstate = null;
    setLoading(true);

    let Data1 = {
      guardarDatos,
      datosCotizador: {
        ambiente: ambienteAplicacion,
        prodCodigo: 'AUTO',
        cotPasoCodigo: 'guardarDatosRiesgo',
        pasoRiesgo: 'datosAuto',
      },
      items: {
        polCodigo: idPoliza,
        datosRiesgo: {
          sisa: catalogo.sisa,
          marca: catalogo.marca,
          modelo: catalogo.modelo,
          anio: catalogo.anio,
          numSerie: data.numSerie ? data.numSerie : '',
          placas: data.placas ? data.placas : '',
          motor: data.motor ? data.motor : '',
          nci: data.nci ? data.nci : '',
          chasis: data.chasis ? data.chasis : '',
          tipoUso: data.tipoUso ? data.tipoUso : '',
        },
      },
    };
    const res = await ApiKeyFetch.instance().post(urlGuardarDatosRiesgo, Data1);
    console.log(formData);
    methods.reset({ ...formData });
    if (res.transaccion) {
      if (guardarDatos === false) {
        const route = routes.find((e) => e.codigo === 'datosriesgo');
        return history.push(`${route.goTo}`);
      }

      addSuccessToast('Se ha guardado la información de forma correcta');
    } else {
      addWarningToast(
        res.errorDescripcion
          ? res.errorDescripcion
          : 'Ha ocurrido un problema al momento de guardar la información del riesgo'
      );
    }

    setLoading(false);
  };

  const onClickAtras = () => {
    const route = routes.find((e) => e.codigo === 'datosriesgo');
    history.push(`${route.goBack}`);
  };

  const onGuardar = async () => {
    const data = methods.getValues();
    const formData = { ...data };
    await guardarInformacion(data.datosRiesgo, true, formData);
  };

  const handleUpperInput = (value) => {
    return value.toUpperCase();
  };

  return (
    <React.Fragment>
      <Loading loading={loading}>
        <div className="cr-content">
          <Page>
            <Breadcrumcomponent {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasos[7].breadCrumb} />

            <BreadCurmbPasos {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasos[7]} />

            {/* <DevTool control={methods.control}/> */}
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row justify-content-center">
                  <div className="col-11 col-md-11 col-md-10 card-login-mex">
                    <h2
                      className="font-mex mt-4 mb-3 text-mex text-center"
                      style={{ fontSize: '26px' }}
                    >
                      Datos del vehículo
                    </h2>

                    <div className="row">
                      <div className="col-12 ml-5">
                        <div className="d-flex flex-row"></div>
                      </div>

                      <div className="col-12">
                        <div className="row justify-content-center">
                          <div className="col-md-11 col-lg-10">
                            <div className="row justify-content-between">
                              <div className="form-group col-md-6 col-lg-5 ">
                                <SimpleContainer
                                  label={'Marca'}
                                  name="datosRiesgo.marca"
                                  classContainer="tipo-detalle"
                                >
                                  {catalogo.marca}
                                </SimpleContainer>
                              </div>
                              <div className="form-group col-md-6 col-lg-5 ">
                                <SimpleContainer
                                  label={'Modelo'}
                                  name="datosRiesgo.modelo"
                                  classContainer="tipo-detalle"
                                >
                                  {catalogo.modelo}
                                </SimpleContainer>
                              </div>
                              <div className="form-group col-md-6 col-lg-5 ">
                                <SimpleContainer
                                  label={'Año'}
                                  name="datosRiesgo.anio"
                                  classContainer="tipo-detalle"
                                >
                                  {catalogo.anio}
                                </SimpleContainer>
                              </div>
                              {/* <div className='form-group col-md-6 col-lg-5 '>
                              <SimpleContainer
                                label={"Código sisa"}
                                name='datosRiesgo.sisa'
                                classContainer='tipo-detalle'>
                                {catalogo.sisa}
                              </SimpleContainer>
                            </div> */}
                              <div className="col-md-6 col-lg-5">
                                <HideField name="datosRiesgo.sisa" />
                              </div>
                              <div className="form-group col-md-6 col-lg-5 ">
                                <SimpleContainer
                                  label={'Número de serie'}
                                  name="datosRiesgo.numSerie"
                                  infoImg={imagenes?.imgserie}
                                >
                                  <TextInput
                                    inputProps={{
                                      name: 'datosRiesgo.numSerie',
                                    }}
                                    rules={validacionSerie}
                                    onChangeBn={handleUpperInput}
                                  />
                                </SimpleContainer>
                              </div>
                              <div className="form-group col-md-6 col-lg-5 ">
                                <SimpleContainer
                                  label={'Placa'}
                                  name="datosRiesgo.placas"
                                  infoImg={imagenes?.imgplaca}
                                >
                                  <TextInput
                                    inputProps={{
                                      name: 'datosRiesgo.placas',
                                    }}
                                    rules={{
                                      maxLength: {
                                        value: 10,
                                        message: 'Ingrese un máximo de 10 caracteres',
                                      },
                                    }}
                                  />
                                </SimpleContainer>
                              </div>

                              <div className="form-group col-md-6 col-lg-5 ">
                                <SimpleContainer
                                  label={'Motor'}
                                  name="datosRiesgo.motor"
                                  infoImg={imagenes?.imgmotor}
                                >
                                  <TextInput
                                    inputProps={{
                                      name: 'datosRiesgo.motor',
                                    }}
                                    rules={{
                                      maxLength: {
                                        value: 15,
                                        message: 'Ingrese un máximo de 15 caracteres',
                                      },
                                    }}
                                  />
                                </SimpleContainer>
                              </div>

                              <div className="form-group col-md-6 col-lg-5 ">
                                <SimpleContainer label={'Tipo de uso'} name="datosRiesgo.tipoUso">
                                  <TextInput
                                    inputProps={{
                                      name: 'datosRiesgo.tipoUso',
                                      disabled: true,
                                    }}
                                    rules={{
                                      required: requiredMessage,
                                    }}
                                    onChangeBn={handleUpperInput}
                                  />
                                </SimpleContainer>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </FormProvider>
          </Page>
          <EmisionFooterBarButtons
            onClickAtras={onClickAtras}
            onClickGuardar={onGuardar}
            onClickContinuar={methods.handleSubmit(onSubmit)}
          />
        </div>
      </Loading>
    </React.Fragment>
  );
};

export default withValidarRecuperar(RiesgoAuto);
